export default __webpack_public_path__ + "static/media/TableEmpty.ce5a0819.svg";